// import React from "react";

const AdminPage = () => {
    return (
    console.log("hello")
)
}

export default AdminPage